module.exports = __webpack_public_path__ + "img/1557614103765262338.84fe7552.png";